import { useMsal } from "@azure/msal-react";
import { Spinner, Stack } from "@fluentui/react";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import InformationCallout from "components/controls/InformationCallout";
import LinkTo from "components/controls/LinkTo";
import SnapshotTimeline from "components/controls/SnapshotTimeline";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { MsalTokenSource } from "global/DataSources/MsalTokenSource";
import * as IXrmOptionSet from "model/AttributeOptionSets.type";
import * as IXrmTypes from "model/CRM";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const SnapshotDiscovery = () => {
    const state = useSelector((state: RootState) => state);

    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [loading, setLoading] = useState(false);

    const [links, setLinks] = useState<IXrmTypes.bcbs_groupconfigurationsnapshot[]>([]);

    useEffect(() => {
        (async () => {
            const snapshots: IXrmTypes.bcbs_groupconfigurationsnapshot[] = [];

            const discover = (snapshot: IXrmTypes.bcbs_groupconfigurationsnapshot, ttl: number) => {
                snapshots.push(snapshot);

                if (ttl > 255)
                    return;

                const originatingsnapshot = snapshot._bcbs_originatingsnapshotid_value
                    ? state.status.snapshots?.find(t => t.bcbs_groupconfigurationsnapshotid === snapshot._bcbs_originatingsnapshotid_value)
                    : undefined;

                if (originatingsnapshot)
                    discover(originatingsnapshot, ttl + 1);

                const originatingsnapshot2 = snapshot._bcbs_originatingsnapshot2id_value
                    ? state.status.snapshots?.find(t => t.bcbs_groupconfigurationsnapshotid === snapshot._bcbs_originatingsnapshot2id_value)
                    : undefined;

                if (originatingsnapshot2)
                    discover(originatingsnapshot2, ttl + 1);

            }

            discover(state.data.snapshot, 0);

            setLinks(snapshots)

            // if (snapshot._bcbs_originatingsnapshotid_value) {
            //     dataSource.getbcbs
            // }

        })();
    }, []);

    return <CustomPanel title={"Snapshot Discovery"}
        canCollapse={true}
    >
        {loading &&
            <div>
                <Spinner label={"Loading..."} styles={{ root: { margin: '25px' } }} />
            </div>
        }
        <Stack styles={{ root: { marginTop: '10px' } }}>
            {links.map(snapshot =>
                <Stack.Item key={snapshot.bcbs_groupconfigurationsnapshotid}>
                    <LinkTo snapshot={snapshot} />
                    {snapshot.bcbs_iseffectivedategoldstandard ? "🥈" : ""}
                    {snapshot?.statuscode === IXrmOptionSet.bcbs_groupconfigurationsnapshot.statuscode["Gold Standard(808900006)"].value ? "🥇" : ""}
                    {state.status.debug.diagnosis &&
                        <InformationCallout>
                            <div>
                                <SnapshotTimeline snapshot={snapshot} />
                            </div>
                        </InformationCallout>
                    }

                </Stack.Item>
            )}
        </Stack>
    </CustomPanel>;

}


export default SnapshotDiscovery;